import { store } from "store";
import { CreateBase } from "easy-redux-http-call";

export const apiBase = new CreateBase({
  baseApiUrl: process.env.REACT_APP_API,

  store: store,
  defaultState: { loading: false },
  validateHttpResponse: (res) => res.status,
  httpFn: (data) => {
    let api_endpoint = "";
    if (data.method === "get") {
      const searchParams = new URLSearchParams(data.params);
      const url = `${data.endpoint}?${searchParams.toString()}`;
      api_endpoint = url;
    } else {
      api_endpoint = data.endpoint;
    }
    if (
      data?.headers &&
      data?.headers["Content-Type"] == "multipart/form-data"
    ) {
      return window
        .fetch(api_endpoint, {
          method: data.method,
          headers: {
            Authorization: localStorage.getItem("token"),
          },
          body: data.params,
        })
        .then(async (res) => {
          let data = await res.json();
          // for token invalid or token change
          if (parseInt(res.status) === 401) {
            localStorage.clear();
            window.location.reload();
          }
          return {
            status: res.status,
            data,
          };
        });
    } else
      return window
        .fetch(api_endpoint, {
          method: data.method,
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
            ...(data.headers || {}),
          },
          ...(Object.keys(data.params || {}).length &&
            data.method.toLowerCase() !== "get" && {
              body: JSON.stringify(data.params),
            }),
        })
        .then(async (res) => {
          let data = await res.json();
          // for token invalid or token change
          if (parseInt(res.status) === 401) {
            localStorage.clear();
            window.location.reload();
          }
          return {
            status: res.status,
            data,
          };
        });
  },
});
